import axios from "../axios";

const logout = async () => {
    try {
        const response = await axios.post('auth/logout', {});
        return response.data;
    }
    catch (e) {
        return {
            success: false,
            errorCode: e.response?.status || 500,
            message: e.message
        }
    }
}

export default logout;
